import Cookies from 'js-cookie';
import { buildStateParam } from '@yme/utils/common';
import { ROOT_PATH, SALES_FORCE_AUTHORIZE_ENDPOINT, SALES_FORCE_LOGOUT_ENDPOINT, SALES_FORCE_SIGN_UP_ENDPOINT, } from '../../../common/endpoints';
import { QUERY_CLIENT_ID, QUERY_LANGUAGE, QUERY_REDIRECT_URI, QUERY_RESPONSE_TYPE, QUERY_STATE, RESPONSE_TYPE_CODE, } from './constants';
function buildUrlSign({ url, state }) {
    return Buffer.from(`uri[${url}]sign[${state}]`).toString('base64');
}
function buildEndpointLogIn({ myYamahaLink, clientId, callbackEndpointUri, currentPage, state, }) {
    if (clientId) {
        const sign = buildUrlSign({
            url: currentPage,
            state,
        });
        const queryParams = [
            `${QUERY_CLIENT_ID}=${clientId}`,
            `${QUERY_REDIRECT_URI}=${callbackEndpointUri}`,
            `${QUERY_RESPONSE_TYPE}=${RESPONSE_TYPE_CODE}`,
            `${QUERY_STATE}=${sign}`, // signature for csrf requests validation
        ].join('&');
        return `${myYamahaLink}${SALES_FORCE_AUTHORIZE_ENDPOINT}?${queryParams}`;
    }
    return '';
}
export function buildEndpointSignUp({ myYamahaLink, language }) {
    const queryParams = [`${QUERY_LANGUAGE}=${language}`].join('&');
    return `${myYamahaLink}${SALES_FORCE_SIGN_UP_ENDPOINT}?${queryParams}`;
}
export function buildEndpointLogOut({ myYamahaLink }) {
    return `${myYamahaLink}${SALES_FORCE_LOGOUT_ENDPOINT}`;
}
export function getSingInLink({ myYamahaLink, clientId, callbackEndpointUri }) {
    const currentPage = window.location.href;
    const state = buildStateParam();
    const path = buildEndpointLogIn({
        myYamahaLink,
        clientId,
        callbackEndpointUri,
        currentPage,
        state,
    });
    Cookies.set(QUERY_STATE, state, {
        path: ROOT_PATH,
    });
    return path;
}
